import { FormattedMessage } from 'react-intl';
import Link from 'next/link';
import { Icon } from 'components/ui/atoms/icons';

type OrderDetailsLinkProps = {
  orderNumber: string;
};

export const OrderDetailsLink = ({ orderNumber }: OrderDetailsLinkProps) => (
  <Link
    href={`/order-details?order_number=${orderNumber}`}
    className="d-flex align-items-center tw-text-info-500"
  >
    <FormattedMessage
      id="payment.order.history.cell.view.order.details"
      defaultMessage="View Order Details"
      description="Link to an order receipt"
    />
    <div className="ml-2">
      <Icon
        type="open-in-new"
        svgProps={{ style: { width: 14, height: 14 } }}
      />
    </div>
  </Link>
);
